export const authRoutes = [
    {
      name: 'access-denied',
      path: '/auth/denied',
      component: () => import('@/views/auth/AccessDenied'),
      meta: {
        title: 'Access denied'
      }
    }
  ];
  